// Phase 1 (ngUpgrade) — webpack entry point + hybrid bootstrap.
//
// Ordering is the one thing that matters here:
//   1. zone.js   — Angular's change-detection patch; must load before Angular.
//      (Phase 3.5: app code is AOT-compiled and partial-Ivy libs are linked at
//      build time, so the old reflect-metadata / @angular/compiler imports are gone.)
//   2. _module   — defines angular.module('UmsApp', [...]) BEFORE any app file runs
//      `app.controller(...)` etc. (the AngularJS registration ordering constraint).
//   3. require.context — pull in every legacy app .js file. ProvidePlugin injects
//      `app` / `_pb` / `_` / `moment` / `$` / `io` / `angular` into each.
//   4. Bootstrap AppModule once the DOM is ready; its ngDoBootstrap() then runs
//      upgrade.bootstrap(document.body, ['UmsApp']). `ng-app` was removed from
//      index.html so AngularJS no longer auto-bootstraps (avoids double-bootstrap).

import 'zone.js';
import './_module';
import './ng/downgrades'; // hoisted: runs after _module, before require.context (old files deleted)

const ctx = require.context('./', true, /\.js$/);
ctx.keys().forEach((key) => ctx(key));

import { NgZone } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { platformBrowser } from '@angular/platform-browser';
import { UIRouter } from '@uirouter/angular';
import { AppModule } from './app.module';

// `angular` is injected by ProvidePlugin at build time (see webpack.config.js).
declare const angular: any;

// bundle.js loads in <head>, so wait for <body> to exist before upgrade.bootstrap
// reaches for document.body.
angular.element(document).ready(() => {
    platformBrowser()
        .bootstrapModule(AppModule)
        .then((moduleRef) => {
            // Phase 2: routing was deferred via $urlServiceProvider.deferIntercept().
            // Restore the session FIRST so the onBefore auth guard sees the real auth
            // state, THEN start the shared URL service inside NgZone.
            const injector = moduleRef.injector;
            const urlService = injector.get(UIRouter).urlService;
            const zone = injector.get(NgZone);
            const startRouter = () => zone.run(() => {
                urlService.listen();
                urlService.sync();
            });

            // The password-restore link is meant to work for anonymous visitors
            // (e.g. arriving from an emailed reset link); skip the session-restore
            // call for it so /auth/passport isn't hit on that page.
            const skipRestore = /^#!\/restore\//.test(window.location.hash);
            let restore: any;
            if (!skipRestore) {
                try {
                    restore = injector.get(UpgradeModule).$injector.get('AuthService').restore();
                } catch (e) {
                    console.error('AuthService.restore() unavailable; starting router anyway', e);
                }
            }
            if (restore && typeof restore.finally === 'function') restore.finally(startRouter);
            else if (restore && typeof restore.then === 'function') restore.then(startRouter, startRouter);
            else startRouter();
        })
        .catch((err) => console.error(err));
});
